import { Box, Button, Text } from '@opendoor/bricks-next';

import { StateLinkList } from './StateLinkList';
import type { StateLink } from './StateLinkList';

interface EmptyStateNearbyProps {
  stateName: string;
  nearestStates: StateLink[];
  allStates: StateLink[];
}

export const EmptyStateNearby: React.FC<EmptyStateNearbyProps> = ({
  stateName,
  nearestStates,
  allStates,
}) => {
  return (
    <Box>
      <Box py="$12x" px="$6x" alignItems="center">
        <Box maxWidth={800} width="100%" style={{ textAlign: 'center' }}>
          <Text tag="h1" typography="$headerLarge" mb="$6x">
            Homes for Sale in {stateName}
          </Text>

          <Text tag="p" typography="$bodyLarge" mb="$8x">
            No homes available in {stateName} yet. Browse these homes in nearby states:
          </Text>

          <Box
            flexDirection="row"
            justifyContent="center"
            flexWrap="wrap"
            mb="$8x"
            style={{ gap: '1rem' }}
          >
            {nearestStates.length > 0 ? (
              nearestStates.map((state) => (
                <Button
                  key={state.slug}
                  analyticsName="nearby-state-link"
                  href={`/homes/state/${state.slug}`}
                  variant="secondary"
                  size="large"
                  label={`${state.name} (${state.count} ${state.count === 1 ? 'home' : 'homes'})`}
                />
              ))
            ) : (
              <Button
                analyticsName="view-all-markets"
                href="/homes"
                variant="primary"
                size="large"
                label="View all available markets"
              />
            )}
          </Box>

          <Box mt="$12x">
            <Button
              analyticsName="view-all-markets-footer"
              href="/homes"
              variant="secondary"
              size="medium"
              label="View all available markets →"
            />
          </Box>
        </Box>
      </Box>

      <StateLinkList states={allStates} />
    </Box>
  );
};
